export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\" data-name=\"Bounding box\"/><g data-name=\"Layer 1\" fill=\"#3f4450\"><rect y=\"6\" width=\"4\" height=\"10\" rx=\"1\"/><rect x=\"6\" width=\"4\" height=\"16\" rx=\"1\"/><rect x=\"12\" y=\"3\" width=\"4\" height=\"13\" rx=\"1\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};